import { Tooltip } from "../components/tooltip";

type selectOptionsType = {
  label: string;
  value: string | number | any;
};

interface IFormSelectProps {
  register: any;
  errors: any;
  className?: string;
  disabled?: boolean;
  placeholder?: string;
  noTranslate?: boolean;
  name: string;
  title: string;
  disabledOption?: number | string | any;
  defaultValue?: number | string | any;
  mapOptions?: (op: any) => void;
  tooltip?: string;
  options: selectOptionsType[] | any;
  t: any;
}

export function HookFormSelect({
  register,
  errors,
  className,
  disabled,
  noTranslate,
  options,
  name,
  mapOptions,
  disabledOption,
  defaultValue,
  tooltip,
  title,
  t,
}: IFormSelectProps) {
  const formatOptions = (opt: any): selectOptionsType[] => {
    if (options && mapOptions) {
      return opt.map((item: any) => mapOptions(item));
    }
    return opt;
  };

  const _options = formatOptions(options);
  return (
    <div className={`${className || ""} w-full`}>
      <label htmlFor={name} className="w-full block mb-1 text-textColor">
        {title} {tooltip ? <Tooltip text={tooltip} /> : null}
      </label>

      <select
        key={_options}
        id={name}
        disabled={disabled || false}
        defaultValue={defaultValue || ""}
        className={`${
          className || ""
        } select input input-bordered w-full focus:outline-hoverColor cursor-pointer`}
        {...register(name)}
      >
        {_options?.length === 0 ? (
          <option disabled className="bg-gray-200">
            {t("Form.noSelectOptions")}
          </option>
        ) : (
          <>
            <option className="bg-gray-200" disabled value="">
              {t("Form.select")}
            </option>
            {_options.map((option, index) => {
              return (
                <option
                  value={option.value}
                  key={index}
                  disabled={disabledOption === option.value || false}
                  className={
                    disabledOption === option.value ? "bg-gray-200" : ""
                  }
                >
                  {noTranslate
                    ? option.label
                    : t(`Options.${option.label}` as any)}
                </option>
              );
            })}
          </>
        )}
      </select>

      {errors[`${name}`]?.message ? (
        <p className="text-sm my-3 text-error">
          {t(`${errors[`${name}`]?.message}` as any)}
        </p>
      ) : null}
    </div>
  );
}
